import { Typography } from "@shared/ui.primitives"
import React, { Fragment } from "react"

import * as styles from "./ProductAttributes.css"

type ProductAttributesProps = {
  attributes: string[]
}

export const ProductAttributes: React.FC<ProductAttributesProps> = ({
  attributes,
}) => {
  return (
    <div className={styles.productAttributesContainer}>
      {attributes.map((attribute, index) => (
        <Fragment key={index}>
          <Typography
            as="span"
            variant="smallprint-md-bold"
            key={`${index}-${attribute}`}
            colour="primary-medium"
            whiteSpace="nowrap"
          >
            {attribute}
          </Typography>
          {index !== attributes.length - 1 && (
            <Typography
              as="span"
              variant="smallprint-md-bold"
              colour="primary-medium"
              whiteSpace="nowrap"
            >
              •
            </Typography>
          )}
        </Fragment>
      ))}
    </div>
  )
}
